import React, { useEffect, useMemo, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import TaskApiService from '../../api/TaskApiService';
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarExport,
    GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRefetchTrigger } from '../../hooks/useRefetchTrigger';

const taskApiService = new TaskApiService();
const defaultExcludedStatusIds = [9];

const parseSettings = (settings) => {
    try {
        if (!settings || settings === '{}') {
            return {};
        }

        return typeof settings === 'string' ? JSON.parse(settings) : settings;
    }
    catch (error) {
        console.error('Error parsing jsonSettings:', error);
        return {};
    }
};

const getExcludedStatusIds = (settings) => {
    if (!Object.prototype.hasOwnProperty.call(settings, 'excludedStatusIds')) {
        return defaultExcludedStatusIds;
    }

    return Array.isArray(settings.excludedStatusIds) ? settings.excludedStatusIds : [];
};

const DashboardUserAssignedTasks = ({ jsonSettings }) => {
    const { t } = useTranslation();
    const refetchTrigger = useRefetchTrigger();
    const [userTasks, setUserTasks] = useState([]);
    const [taskStatuses, setTaskStatuses] = useState([]);

    useEffect(() => {
        const excludedStatusIds = getExcludedStatusIds(parseSettings(jsonSettings));

        taskApiService.getTaskStatuses().then((statuses) => {
            setTaskStatuses(statuses);
        });

        taskApiService.getTaskUser(excludedStatusIds).then((user) => {
            setUserTasks(user);
        });
    }, [jsonSettings, refetchTrigger]);

    const userTasksColumns = useMemo(() => [
        {
            field: 'id',
            headerName: t('dashboardUserAssignedTasks.column.id'),
            flex: 1,
            renderCell: (params) => <Link to={`/Task/${params.value}`}>{params.value}</Link>,
        },
        { field: 'shortDescription', headerName: t('dashboardUserAssignedTasks.column.description'), flex: 3 },
        {
            field: 'statusId',
            headerName: t('dashboardUserAssignedTasks.column.status'),
            flex: 3,
            renderCell: (params) => {
                const match = taskStatuses.find((status) => status.stId === params.value);
                return match ? (match.localizedName ?? match.stName) : '';
            },
        },
    ], [t, taskStatuses]);

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }

    return (
        <Grid container direction="column" spacing={2} style={{ height: '100%', width: '100%', overflow: 'auto' }}>
            <Grid item>
                <Typography variant="h6">{t('dashboardUserAssignedTasks.title')}</Typography>
            </Grid>
            <Grid item style={{ flexGrow: 1, width: '100%' }}>
                <div style={{ height: '100%', width: '100%' }}>
                    <DataGridPro
                        rows={userTasks}
                        localeText={{ noRowsLabel: t('dashboardUserAssignedTasks.noTasks') }}
                        columns={userTasksColumns}
                        getRowHeight={() => 'auto'}
                        getRowId={(row) => row.id}
                        components={{
                            Toolbar: CustomToolbar,
                        }}
                        pagination
                        autoHeight={false}
                    />
                </div>
            </Grid>
        </Grid>
    );
};
export default DashboardUserAssignedTasks;
